export class RegExConstants {
  static readonly ERP_PROJECT_NUMBER_REGEX = /^[A-Z]{2,3}-PRJ-\d{6}$/;
  static readonly PSA_PROJECT_ID_REGEX = /^[A-Z]{2,3}-(PRJ|OPP)-\d{6}$/;
  static readonly ONE_SALES_ID_REGEX = /^[A-Z]{3}-[12]\d{3}-\d{6}(-\d+)?$/;
}
